import React, {ChangeEvent, ChangeEventHandler} from "react";
import {usePlacesWidget} from "react-google-autocomplete";
import {toast} from "react-toastify";
import onChange = toast.onChange;
import {useApiIsLoaded} from "@vis.gl/react-google-maps";



export const BARRECA_CENTER = { lat: 41.9035, lng: -87.939980 }; // lat/lng of Barreca
const milesRadius = 125; // approx miles from center point to service
const kmRadius = milesRadius * 1.60934
const defaultBounds = { // a .01 change is close enough 1 km 
    north: BARRECA_CENTER.lat + (kmRadius * .01),
    south: BARRECA_CENTER.lat - (kmRadius * .01),
    east: BARRECA_CENTER.lng + (kmRadius * .01),
    west: BARRECA_CENTER.lng - (kmRadius * .01),
};
type AddressInputProps = {
    onLocation: (p: { lng: number; lat: number }) => void,
    setPlace: (place: any) => void,
    addressMissing?: boolean,
    className: string
    defaultValue?: string
}

const AddressInput: React.FC<AddressInputProps> = (props) => {
    const apiIsLoaded = useApiIsLoaded();
    if (!apiIsLoaded) {
        return <input placeholder="Address" defaultValue={props.defaultValue ?? ''}
                      className={props.className + (props.addressMissing ? ' is-invalid' : '')} readOnly/>
    }
    return <AddressInputWidget {...props}/>
}

const AddressInputWidget: React.FC<AddressInputProps> = ({onLocation, setPlace, addressMissing, className, defaultValue = ''}) => {
    const { ref } = usePlacesWidget({
        onPlaceSelected: place => {
            if(place && place.geometry)
                if (place.geometry?.location) {
                    onLocation({
                        lat: place.geometry.location.lat(),
                        lng: place.geometry.location.lng(),
                    });
                }
            setPlace(place);
        },
        options: {
            types: ["address"],
            bounds: defaultBounds,
            strictBounds: true,
        },
    });
    return <>
        <input ref={ref} placeholder="Address" defaultValue={defaultValue} className={className + (addressMissing ? ' is-invalid' : '')} />
        {addressMissing && (
            <div className="invalid-feedback">
                This is a required field
            </div>
        )}
    </>
}

export default AddressInput;